(function($, moment) {
    'use strict';

    var SynchronizeInputs = function (selector, type) {
        var element = typeof selector === 'string' ? document.querySelector(selector) : selector;
        var hiddenField = element.querySelector('input[type="text"]');
        var field = element.querySelector('input[type="'+ type +'"]');

        if (hiddenField === null || field === null) {
            console.warn('hidden field and/or field not found.');
            return;
        }

        var init = function () {
            addEventListeners();
            setValue();
        };

        var addEventListeners = function () {
            field.addEventListener('input', onChange);
            field.addEventListener('blur', onBlur);
        };

        var setValue = function () {
            var hiddenValue = hiddenField.value;

            if (!hiddenValue.length) {
                return; // Early return if no value is set
            }

            // Synchronize values: Hidden input to fake input
            if (type === 'date') {
                // Set required format for input[type="date"]
                field.value = moment(hiddenValue, 'DD/MM/YYYY').format('YYYY-MM-DD');
            } else {
                field.value = hiddenValue;
            }
        };

        var onChange = function () {
            // Synchronize values: Fake input to hidden input
            if (type === 'date') {
                // Set required format for phaneuf calendar
                hiddenField.value = moment(this.value).format('DD/MM/YYYY');
            } else {
                hiddenField.value = this.value;
            }
        };

        var onBlur = function () {
            // Trigger save/validation
            $(hiddenField).trigger('change');
        };

        init();
    };

    $('body').on('app.init', function (ev) {
        var $container = $(ev.container);
        var syncDateInputs = $container.find('[sync-input="date"]');
        var syncTimeInputs = $container.find('[sync-input="time"]');

        if (syncDateInputs.length) {
            syncDateInputs.each(function (i) {
                SynchronizeInputs(syncDateInputs[i], 'date');
            });
        }

        if (syncTimeInputs.length) {
            syncTimeInputs.each(function (i) {
                SynchronizeInputs(syncTimeInputs[i], 'time');
            });
        }
    });

}(jQuery, require('moment')));
